import React from "react";
import { Container, Row, Col, Card, CardBody, CardDeck, CardFooter } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import CertificateTemplateSelection from "../../components/Certificates/CertificateTemplateSelection";
import { useUser } from "../../context/UserContext";
import roles from "../../identity/roles";

function Certificates({ history }) {
  const { user } = useUser();

  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="certificates.title" defaultMessage="Certificates" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          {user.role === roles.SystemAdministrator && (
            <Col sm={4}>
              <CardDeck>
                <Card>
                  <CardBody>
                    <Row>
                      <Col>
                        <h3 className="card-title">
                          <FormattedMessage id="certificates.create_new.title" defaultMessage="Create a new certificate" />
                        </h3>
                        <p className="card-text">
                          <FormattedMessage
                            id="certificates.create_new.description"
                            defaultMessage="Click the button below if you would like to create a new certificate for a specific series"
                          />
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <Link to="/certificates/new" className="btn btn-outline-primary">
                      <FormattedMessage id="app.proceed" defaultMessage="Proceed" />
                    </Link>
                    <Link to="/certificates/link_nota_cert" className="btn btn-outline-primary">
                      <FormattedMessage id="certificates.linknotacert" defaultMessage="Link NotaCERT" />
                    </Link>
                  </CardFooter>
                </Card>
              </CardDeck>
            </Col>
          )}
          <Col sm={user.role === roles.SystemAdministrator ? 4 : 6}>
            <CardDeck>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <h3 className="card-title">
                        <FormattedMessage id="certificates.create_new_declaration.title" defaultMessage="Create a new Declaration" />
                      </h3>
                      <p className="card-text">
                        <FormattedMessage
                          id="certificates.create_new_declaration.description"
                          defaultMessage="Click the button below if you would like to create a new certificate for a specific series"
                        />
                      </p>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Link to="/certificates/declaration/new" className="btn btn-outline-primary">
                    <FormattedMessage id="app.proceed" defaultMessage="Proceed" />
                  </Link>
                  <Link to="/certificates/declaration/upload" className="btn btn-outline-primary">
                    <FormattedMessage id="app.upload_pdf" defaultMessage="Upload PDF" />
                  </Link>
                </CardFooter>
              </Card>
            </CardDeck>
          </Col>
          <Col sm={user.role === roles.SystemAdministrator ? 4 : 6}>
            <CardDeck>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <h3 className="card-title">
                        <FormattedMessage id="certificates.clone_declaration.title" defaultMessage="Clone a Declaration" />
                      </h3>
                      <p className="card-text">
                        <FormattedMessage
                          id="certificates.clone_declaration.description"
                          defaultMessage="Click the button below if you would like to clone an existing certificate."
                        />
                      </p>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Link to="/certificates/declaration/clone" className="btn btn-outline-primary">
                    <FormattedMessage id="app.proceed" defaultMessage="Proceed" />
                  </Link>
                </CardFooter>
              </Card>
            </CardDeck>
          </Col>
        </Row>
        <Row>
          <Col>
            <h1 className="my-4">
              <FormattedMessage id="certificates.view.title" defaultMessage="View existing certificates" />
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <p className="card-text">
                      <FormattedMessage id="certificates.view_certificate.description" defaultMessage="Select from the options below to generate and view certificate." />
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-3">
                    <CertificateTemplateSelection history={history}></CertificateTemplateSelection>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Certificates;
